export const formatAllocationAmountTitle = (
  title?: string,
  amount?: string,
) => {
  const amountVal = amount ? ` (${amount})` : '';
  return `${title}${amountVal}`;
};
